import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { TermsOfUseWorkspace } from '@/components/screens/onboarding/terms-of-use-workspace'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/terms_of_use')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const navigate = useNavigate()
  const me = useMe()

  return (
    <TermsOfUseWorkspace
      tenantName={me.tenant.name}
      onContinue={() => {
        void navigate({
          to: '/t/$tenant_id/plan/confirm',
          params: { tenant_id: tenantId },
        })
      }}
      onSignOut={() => {
        void navigate({ to: '/sign_out' })
      }}
    />
  )
}
